"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.platformDTypeList = void 0;
__exportStar(require("./components/PlatformAudioComponent"), exports);
__exportStar(require("./components/PlatformImageComponent"), exports);
__exportStar(require("./components/PlatformTextComponent"), exports);
__exportStar(require("./components/PlatformLocaleTextComponent"), exports);
__exportStar(require("./components/PlatformVideoComponent"), exports);
__exportStar(require("./components/PlatformImageMaskComponent"), exports);
__exportStar(require("./components/PlatformOpenComponent"), exports);
exports.platformDTypeList = {
    TEXT: 'Text',
    LOCALE_TEXT: 'Localizable Text',
    AUDIO: 'Audio',
    IMAGE: 'Image',
    VIDEO: 'Video',
    IMAGE_MASK: 'Image Mask',
    OPEN: 'Open',
};
//# sourceMappingURL=Index.js.map